import React,
{
    forwardRef,
    useImperativeHandle,
    useState,
} from "react";

import { toast } from "react-toastify";

import spiner from "../../assets/img/spiner.gif";


import * as b2cleadService from "../../Services/b2cleadService"

const B2CExportModalComponent = forwardRef(({
    filters,
    status,
    Token,
    page,
    pageSize,
}, ref) => {

    const [isModalOpen, setIsModalOpen] =
        useState(false);

    const [isLoading, setIsLoading] =
        useState(false);

    /* =========================
       CLOSE MODAL
    ========================= */

    const handleCloseModal = () => {

        setIsModalOpen(false);

        document.body.classList.remove(
            "modal-open"
        );

    };

    /* =========================
       REF METHODS
    ========================= */

    useImperativeHandle(ref, () => ({

        toggle: () => {

            setIsModalOpen(
                (prev) => !prev
            );

            document.body.classList.add(
                "modal-open"
            );

        },

        open: () => {

            setIsModalOpen(true);

            document.body.classList.add(
                "modal-open"
            );

        },

        close: () => {

            handleCloseModal();

        },

    }));


    //    EXPORT HANDLE


    const handleConfirm = async () => {

        try {

            setIsLoading(true);

            // STATUS HANDLING
            let masterStatus = "";
            let leadStatus = "";

            if (status === "Won") {

                masterStatus = "Won";

            } else if (status === "Lost") {

                masterStatus = "Lost";

            } else if (
                status !== "Open" &&
                status !== "All-leads"
            ) {

                leadStatus = status;

            }

            // console.log("FILTER =>", filteringConditions);
            // console.log("PAGE =>", page);
            // console.log("PAGESIZE =>", pageSize);
            // console.log("TOTAL =>", leadsData.length);

            // PAYLOAD
            const payload = {


                search:
                    filters.search || "",

                accountType:filters.accountType,

                leadType:
                    filters.leadType || "",

                leadSource:
                    filters.leadSource
                        ?.map((i) => i.value)
                        .join(",") || "",

                leadPipeline:
                    filters.leadPipeline
                        ?.map((i) => i.value)
                        .join(",") || "",

                businessCategory:
                    filters.businessCategory
                        ?.map((i) => i.value)
                        .join(",") || "",

                currentShippingPartner:
                    filters.currentShippingPartner
                        ?.map((i) => i.value)
                        .join(",") || "",

                shipmentPotential:
                    filters.shipmentPotential
                        ?.map((i) => i.value)
                        .join(",") || "",

                clientPersona:
                    filters.clientPersona
                        ?.map((i) => i.value)
                        .join(",") || "",

                employeeId:
                    filters.employeeId
                        ?.map((i) => i.value)
                        .join(",") || "",

                isKycDone:
                    filters.isKycDone
                        ?.map((i) => i.value)
                        .join(",") || "",

                utmSource:
                    filters.utmSource
                        ?.map((i) => i.value)
                        .join(",") || "",

                utmMedium:
                    filters.utmMedium
                        ?.map((i) => i.value)
                        .join(",") || "",

                utmCampaign:
                    filters.utmCampaign
                        ?.map((i) => i.value)
                        .join(",") || "",

                minimumExpectedShipmentToFship:
                    filters.minimumExpectedShipmentToFship || "",

                genericEmailPattern:
                    filters.genericEmailPattern || "",

                from:
                    filters.from || "",

                to:
                    filters.to || "",

                status: leadStatus,

                masterStatus,
                // page,
                // pageSize,

            };

            // API CALL
            const response =
                await b2cleadService
                    .b2cExportExcel(
                        payload,
                        Token
                    );

            // BLOB
            const blob =
                response?.data instanceof Blob
                    ? response.data
                    : new Blob([response.data]);

            // FILE NAME
            const fileName = `leads_${Date.now()}.xlsx`;

            // DOWNLOAD URL
            const downloadUrl =
                window.URL.createObjectURL(blob);

            // CREATE LINK
            const link =
                document.createElement("a");

            link.href = downloadUrl;

            link.download = fileName;

            document.body.appendChild(link);

            link.click();

            link.remove();

            // CLEAR URL
            window.URL.revokeObjectURL(
                downloadUrl
            );

            toast.success(
                "Excel Downloaded Successfully"
            );

            handleCloseModal();

        }

        catch (error) {

            console.log(
                "EXPORT ERROR",
                error
            );

            toast.error(
                "Download Failed"
            );

        }

        finally {

            setIsLoading(false);

        }

    };

    return (

        <div
            className={`modal fade ${isModalOpen
                ? "show d-block"
                : ""
                }`}
            tabIndex="-1"
            style={{
                background:
                    "rgba(15,23,42,0.55)",

                backdropFilter:
                    "blur(5px)",
            }}
        >

            <div className="modal-dialog modal-dialog-centered">

                <div
                    className="modal-content border-0 overflow-hidden"
                    style={{
                        borderRadius:
                            "26px",

                        boxShadow:
                            "0 25px 70px rgba(0,0,0,0.18)",
                    }}
                >

                    {/* HEADER */}
                    <div
                        className="position-relative"
                        style={{
                            background:
                                "linear-gradient(135deg,#2563eb,#1d4ed8)",

                            height:
                                "100px",
                        }}
                    >

                        {/* CLOSE */}
                        <button
                            type="button"
                            onClick={
                                handleCloseModal
                            }
                            className="btn btn-light rounded-circle position-absolute"
                            style={{
                                top: "18px",
                                right:
                                    "18px",

                                width:
                                    "38px",

                                height:
                                    "38px",
                            }}
                        >

                            <i className="fa fa-times"></i>

                        </button>

                        {/* ICON */}
                        <div
                            className="position-absolute start-50 translate-middle"
                            style={{
                                bottom:
                                    "-45px",
                            }}
                        >

                            <div
                                className="bg-white d-flex align-items-center justify-content-center shadow"
                                style={{
                                    width:
                                        "50px",

                                    height:
                                        "50px",

                                    borderRadius:
                                        "28px",
                                }}
                            >

                                <i
                                    className="fa fa-file-excel-o text-success"
                                    style={{
                                        fontSize:
                                            "42px",
                                    }}
                                ></i>

                            </div>

                        </div>

                    </div>

                    {/* BODY */}
                    <div
                        className="text-center px-4"
                        style={{
                            paddingTop:
                                "70px",

                            paddingBottom:
                                "35px",
                        }}
                    >

                        <h3 className="fw-bold mb-2">
                            Export Leads
                        </h3>

                        <p
                            className="text-muted mb-4 mx-auto"
                            style={{
                                maxWidth:
                                    "320px",

                                fontSize:
                                    "15px",

                                lineHeight:
                                    "24px",
                            }}
                        >

                            Download filtered
                            leads data in Excel
                            format with all
                            applied filters and
                            lead details.

                        </p>

                        {isLoading ? (

                            <div className="py-3">

                                <img
                                    src={spiner}
                                    alt="Loading"
                                    style={{
                                        width:
                                            "58px",

                                        height:
                                            "58px",
                                    }}
                                />

                                <h6 className="mt-3 fw-semibold text-primary">

                                    Preparing Excel
                                    File...

                                </h6>

                            </div>

                        ) : (

                            <div className="d-flex justify-content-center gap-3">

                                <button
                                    className="btn btn-light border rounded-pill px-4 fw-semibold"
                                    style={{
                                        minWidth:
                                            "130px",

                                        height:
                                            "48px",
                                    }}
                                    onClick={
                                        handleCloseModal
                                    }
                                >

                                    Cancel

                                </button>

                                <button
                                    className="btn btn-primary rounded-pill px-4 fw-semibold"
                                    style={{
                                        minWidth:
                                            "180px",

                                        height:
                                            "48px",

                                        boxShadow:
                                            "0 10px 25px rgba(37,99,235,0.25)",
                                    }}
                                    onClick={
                                        handleConfirm
                                    }
                                >

                                    <i className="fa fa-download me-2"></i>

                                    Download Excel

                                </button>

                            </div>

                        )}

                    </div>

                </div>

            </div>

        </div>

    );

});

export default B2CExportModalComponent;